module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "overlay"
  }, [_h('div', {
    staticClass: "overlay-content"
  }, [_h('a', {
    staticClass: "overlay-close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": back
    }
  }, ["✕"]), " ", _m(0)])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "overlay-inner"
  }, [_h('div', {
    staticClass: "cleanmap"
  }, [_h('h2', ["Impressum"]), " ", _h('p', ["Christian Huder", _h('br'), "\n          Rudolfstraße 10", _h('br'), "\n          10245 Berlin"]), " ", _h('h3', ["Contact"]), " ", _h('p', ["email: hello@innergy.berlin", _h('br'), "\n          phone: (49) 3068322626"])])])
}}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32a0a31c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Impressum.vue
// module id = 37
// module chunks = 1